import { markierungMapper } from '@/utils';
import { Markierung } from '../../../Markierung';
import { Arbeitsbereich } from '../entities/Arbeitsbereich';
import { ToDoRowModel } from '../entities/Entities';
import { Konflikt } from '../entities/Konflikt';
import { CellContent } from '../ToDoTableContent';

export function ArbeitsbereichCell({ row }: { row: ToDoRowModel }) {
  if (row instanceof Konflikt) {
    return (
      <div className="flex flex-col w-full">
        <CellContent className="border-b-2 border-primary-blue-B500">
          <ArbeitsbereichCellContent
            arbeitsbereich={row.rootArbeitszeit.arbeitsbereich}
          />
        </CellContent>
        <CellContent>
          <ArbeitsbereichCellContent
            arbeitsbereich={row.conflictCause.arbeitsbereich}
          />
        </CellContent>
      </div>
    );
  }
  return (
    <CellContent>
      <ArbeitsbereichCellContent arbeitsbereich={row.arbeitsbereich} />
    </CellContent>
  );
}

export function ArbeitsbereichCellContent({
  arbeitsbereich,
}: {
  arbeitsbereich: Arbeitsbereich;
}) {
  return (
    <div className="flex gap-2 items-center font-semibold pe-4">
      <Markierung color={markierungMapper[arbeitsbereich.markierung].base} />
      <span>{arbeitsbereich.name}</span>
    </div>
  );
}
